import { createApp } from 'vue';
import RafToJpgConverter from '../Components/RafToJpgConverter.vue';

const root = document.getElementById('raf-to-jpg-converter');
if (root) {
  createApp(RafToJpgConverter).mount('#raf-to-jpg-converter');
}
